import { render, staticRenderFns } from "./InformationTicketItem.vue?vue&type=template&id=17b8cbdd&scoped=true"
import script from "./InformationTicketItem.vue?vue&type=script&lang=js"
export * from "./InformationTicketItem.vue?vue&type=script&lang=js"
import style0 from "./InformationTicketItem.vue?vue&type=style&index=0&id=17b8cbdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8cbdd",
  null
  
)

export default component.exports